module.exports = __webpack_public_path__ + "img/return.2270a409.png";